import { useNuxtData } from '#imports'
import { ref } from 'vue'

import { navigationAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

function cleanMenu(items: navigationAPI.MenuItem[]): navigationAPI.MenuItem[] {
  return items
    .filter((item) => item.title && item.link)
    .map(
      ({ children, ...item }) =>
        <navigationAPI.MenuItem>{
          ...item,
          children,
        },
    )
}

const state = ref<'closed' | 'open'>('closed')

function toggle() {
  if (state.value === 'open') {
    state.value = 'closed'
  } else {
    state.value = 'open'
  }
}

export function useNavigation() {
  const { data } = useHttpFetch(navigationAPI.getSidebar, {
    default: () => [],
    transform: cleanMenu,
    getCachedData: (key) =>
      useNuxtData<navigationAPI.MenuItem[]>(key).data.value,
  })

  return { menu: data, state, toggle }
}
